import {
    UPDATE_CATEGORIE
} from '../actions/categorie-action';

export default function categorieReducer(state = '', {
    type,
    payload
}) {    
    switch (type) {
        case UPDATE_CATEGORIE:
            return payload;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/container/reducers/categorie-reducer.js